var storeEnabled = false;
export var isStoreEnabled = function isStoreEnabled() {
  return storeEnabled;
};
export var enableStore = function enableStore() {
  var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  storeEnabled = enable;
};
export var store = new Set();
export default store;